module.exports = __webpack_public_path__ + "static/service03-aee4a0490e6ed224d5e553fb060562a7.jpg";